import makeBulkContext from './makeBulkContext';

export const { Provider: BulkDeleteContextProvider, useContext: useBulkDeleteContext } = makeBulkContext();
